// src/dashboard/pages/teacher/Palmares/components/VisibilitySwitch.jsx

import React from "react";

export default function VisibilitySwitch({
  checked,
  onChange,
  disabled,
  label,
}) {
  return (
    <label className="inline-flex items-center gap-3">
      <button
        type="button"
        onClick={onChange}
        disabled={disabled}
        role="switch"
        aria-checked={checked}
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition disabled:cursor-not-allowed disabled:opacity-60 ${
          checked ? "bg-emerald-500" : "bg-slate-300 dark:bg-slate-700"
        }`}
        title={checked ? "Affiché sur l’accueil" : "Masqué de l’accueil"}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition ${
            checked ? "translate-x-5" : "translate-x-1"
          }`}
        />
      </button>

      {label ? (
        <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
          {label}
        </span>
      ) : null}
    </label>
  );
}